import { ID, TaskActionType, TaskLinkFields } from '@griply/types';

import { taskGoalIds } from './task-link-ids';

type CountedTask = TaskLinkFields & {
  action?: { type?: TaskActionType | null } | null;
};

// The goals whose task count this task moves: every goal it links to, unless the task IS the
// goal's timeslot — a focus block is not work the goal tracks.
export const countedGoalIds = (task: CountedTask): ID[] =>
  task.action?.type === TaskActionType.GoalTimeslot ? [] : taskGoalIds(task);
